import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

/** @deprecated Please use the `@/modules/format/object/toCamelCaseKeys` module */
export const keysToCamelCase = <T extends object | undefined | null>(
  object: T
): ReturnType<typeof toCamelCaseKeys<T>> => toCamelCaseKeys<T>(object)
